// Example in the helper text is anchored on a Shift ending at 2:00 PM.
const EXAMPLE_SHIFT_END_MINUTES = 14 * 60;

export const formatDuration = (totalMinutes: number): string => {
	const hours = Math.floor(totalMinutes / 60);
	const minutes = totalMinutes % 60;
	const parts = [];
	if (hours > 0) parts.push(`${hours} ${hours === 1 ? "hour" : "hours"}`);
	if (minutes > 0) parts.push(`${minutes} minutes`);
	return parts.join(" ");
};

export const formatSkipGapOption = (minutes: number): string =>
	minutes === 0 ? "No gap (back to back)" : formatDuration(minutes);

export const formatExampleTime = (minutesAfterShiftEnd: number): string => {
	const minutesOfDay =
		(EXAMPLE_SHIFT_END_MINUTES + minutesAfterShiftEnd) % (24 * 60);
	const hours24 = Math.floor(minutesOfDay / 60);
	const minutes = minutesOfDay % 60;
	const hours12 = hours24 % 12 === 0 ? 12 : hours24 % 12;
	const period = hours24 < 12 ? "AM" : "PM";
	return `${hours12}:${String(minutes).padStart(2, "0")} ${period}`;
};

// The API does not validate the exception; it must stay below the minimum gap.
// A gap of 0 hours disables the exception, so there is nothing to check then.
export const isSkipGapInvalid = (settings: {
	minShiftsGapEnabled?: boolean;
	minShiftsGapHours?: number;
	minShiftsGapSkipEnabled?: boolean;
	minShiftsGapSkipMinutes?: number;
}): boolean => {
	const gapHours = Number(settings.minShiftsGapHours ?? 0);
	const skipMinutes = Number(settings.minShiftsGapSkipMinutes ?? 0);
	if (
		!settings.minShiftsGapEnabled ||
		!settings.minShiftsGapSkipEnabled ||
		gapHours <= 0
	) {
		return false;
	}
	return skipMinutes < 0 || skipMinutes >= gapHours * 60;
};
